// Smooth expand/collapse for the site's content-reveal accordions that
// aren't already covered by accordion-animate.js (which only handles the
// Dawn-native ".accordion > details" pattern with a single
// ".accordion__content" child). This covers the custom components used
// for product info tabs, FAQs, and disclosures — several of which have
// MORE than one element after <summary> (e.g. an eyebrow, a subheading,
// and a list), so this animates the <details> element's own height
// directly rather than assuming one specific content wrapper.
//
// Deliberately scoped to these known content-accordion patterns only, not
// a blanket "every <details> on the site" handler — header/menu/search/
// filter/cart-drawer/share-button components also use <details> but drive
// their own open/close behavior and positioning, which was out of scope
// here and risked breaking if intercepted.
(() => {
  if (window.__guttifulAnimatedDetailsInit) return;
  window.__guttifulAnimatedDetailsInit = true;

  const SELECTOR = 'details.benefits-list, .disclosures__details, details.adv-faq-item, details.gc-faq-item';
  const DURATION = 300;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function animate(details, opening) {
    if (details._animatedDetailsAnim) details._animatedDetailsAnim.cancel();

    const startHeight = details.offsetHeight;

    if (opening) details.open = true;
    const summary = details.querySelector(':scope > summary');
    const endHeight = opening ? details.scrollHeight : (summary ? summary.offsetHeight : 0);

    details.style.overflow = 'hidden';
    const anim = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: DURATION, easing: EASING }
    );
    details._animatedDetailsAnim = anim;

    anim.onfinish = () => {
      details.style.height = '';
      details.style.overflow = '';
      if (!opening) details.open = false;
      details._animatedDetailsAnim = null;
    };
    anim.oncancel = () => {
      details.style.height = '';
      details.style.overflow = '';
    };
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(SELECTOR)) return;
    if (summary !== details.querySelector(':scope > summary')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    event.preventDefault();
    animate(details, !details.open);
  });
})();
